(ns kyber.components.composite.rewind
  (:require [re-frame.core :as re-frame]

            [kyber.components.base.button :as button]
            [kyber.styles.core :refer [styles->classes]]))

(def classes
  (styles->classes
   {:icon {:border-radius "50%"}}))

(defn render
  [{:keys [buffering player-key]}]
  [:div {:style {:position :relative}}
   [button/icon-button
    {:class (:icon classes)
     :disabled buffering
     :on-click #(re-frame/dispatch [:media-player/rewind player-key])}
    :undo]])
